// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__CsAKP","Container201":"Hero_Container201__6jFqw","Stars":"Hero_Stars__lxlQ+","Span2":"Hero_Span2__VAhgg","Stars2":"Hero_Stars2__ebfVX","Info":"Hero_Info__3kw9G"};